// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ggy5dL62wnIgBMry4GPG{height:auto;min-height:32px}.yo8wDkyWvQ0CfV0zWloJ{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"docItemOptionRow": `ggy5dL62wnIgBMry4GPG`,
	"docItemOption": `yo8wDkyWvQ0CfV0zWloJ`
};
export default ___CSS_LOADER_EXPORT___;
